import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@shopify/polaris'
import { SHOPIFY_TEXT } from 'components/styles'
import styled from 'styled-components'

const Wrapper = styled.div`
  font-size: 14px;
  line-height: 1;
`
const Icon = styled.span`
  display:flex;
  height:1em;
  width:1em;
  max-height:100%;
  max-width:100%;
  margin:auto;
  justify-content: center;
  align-items: center;
  fill: ${SHOPIFY_TEXT};
`

const ButtonContentWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  font-size: 0.8em;
  margin: -0.8em -0.8em;
`

export default class Breadcrumbs extends Component {
  render () {
    const { title, handler } = this.props
    return (
      <Wrapper>
        <Button plain onClick={handler}>
          <ButtonContentWrapper>
            <a className='Polaris-Breadcrumbs__Breadcrumb' data-polaris-unstyled='true'>
              <Icon>
                <svg className='Polaris-Icon__Svg' viewBox='0 0 20 20'>
                  <path d='M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16'>
                  </path>
                </svg>
              </Icon>
              <span className='Polaris-Breadcrumbs__Content'>{title}</span>
            </a>
          </ButtonContentWrapper>
        </Button>
      </Wrapper>
    )
  }
}

Breadcrumbs.propTypes = {
  title: PropTypes.string,
  handler: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/Breadcrumbs.js